// extracted by mini-css-extract-plugin
export default {"page":"Page_page__L2Y9k"};